module.exports = __webpack_public_path__ + "dash_20_app_assets/img/asfbl.1295bb19.png";